import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../../shared/category.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Stores } from '../../shared/stores.model';
import { StoresService } from '../../shared/stores.service';
import { Observable } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/storage';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {
  stores: Stores[];

  uploadPercent: Observable<number>;
  downloadURL: Observable<string>;
  selectedFIle = null;

  constructor(private service: CategoryService,
    private storeService: StoresService,
    private storage: AngularFireStorage,
    private firestore: AngularFirestore,
    private toastr: ToastrService) { }


  ngOnInit() {
    this.resetForm();
    this.storeService.getStores().subscribe(actionArray => {
      this.stores = actionArray.map(item => {
        const data = item.payload.doc.data() as Stores;
        const id = item.payload.doc.id;
        return { id, ...data };
      })
    });
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.resetForm();
    this.service.categoryData = {
      id: null,
      name: '',
      store: '',
      order: null,
      status: '',
      image: '',

    }

    this.selectedFIle = null;
  }

  onSubmit(form: NgForm) {
    let data = Object.assign({}, form.value)
    let updata = Object.assign({}, form.value)
    data.order = Number(data.order)
    delete data.id;
    delete data.image;
    if (form.value.id == null) {
      if (form.value.image != null) {
        let file = null;
        file = this.selectedFIle;
        const filePath = 'category/' + data.name;
        const fileRef = this.storage.ref(filePath);
        const task = this.storage.upload(filePath, file);

        //observe percentage changes
        this.uploadPercent = task.percentageChanges();
        //get notified when the download URL is available
        task.snapshotChanges().pipe(
          finalize(() => {

            fileRef.getDownloadURL().subscribe(downloadURL => {
              console.log(downloadURL);
              data.image = downloadURL;
              this.firestore.collection('category').add(data);
              //this.toastr.success('Submitted Successfully','Partner Register');
            });
          })
        )
          .subscribe()
      } else {
        data.image = "https://firebasestorage.googleapis.com/v0/b/grocery-c405e.appspot.com/o/NoImage.jpg?alt=media&token=887aef88-4326-4a00-95c0-3fcda3dfcf92"
        this.firestore.collection('category').add(data);
      }
    }

    else {

      let documentId = form.value.id
      console.log(documentId)
      if (form.value.image != null && this.selectedFIle != null) {
        let file = null;
        file = this.selectedFIle;
        const filePath = 'category/' + data.name;
        const fileRef = this.storage.ref(filePath);
        const task = this.storage.upload(filePath, file);

        //observe percentage changes
        this.uploadPercent = task.percentageChanges();
        //get notified when the download URL is available
        task.snapshotChanges().pipe(
          finalize(() => {

            fileRef.getDownloadURL().subscribe(downloadURL => {
              console.log(downloadURL);
              data.image = downloadURL;
              this.firestore.doc('category/' + updata.id).update(data)
              //this.toastr.success('Submitted Successfully','Partner Register');
            });
          })
        )
          .subscribe()
      } else {
        delete data.image;
        this.firestore.doc('category/' + updata.id).update(data)
      }


    }
    this.resetForm(form);
    this.toastr.success('Submitted Successfully', 'Category')
  }

  uploadFile(event) {

    this.selectedFIle = event.target.files[0];
  }


}
